module.exports = __webpack_public_path__ + "static/media/lifeaddwiser.83a54f46.jpg";